import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getPackageDetailsByTransctionIdKey } from "./packages-and-treatments/use-get-package-details-by-transaction-id";
import { getPatientOverviewQueryKey } from "./use-get-patient-overview";
import bookSlot from "../../controllers/appointments/book-slot";

const usePostBookSlot = () => {
  const queryClient = useQueryClient();

  return useMutation(bookSlot, {
    onSuccess: (data) => {
      if (data.data?.patient_oid) {
        queryClient.removeQueries(
          getPatientOverviewQueryKey(data.data.patient_oid)
        );
      }
      queryClient.removeQueries(getPackageDetailsByTransctionIdKey());
    },
  });
};

//TODO - Move Patient overview to a local based query?

export default usePostBookSlot;
